export function useSessionStorage(key) {
    var ls = window.sessionStorage;
    var keySession = "syspm_".concat(key);
    return {
        set: function (value) {
            if (value instanceof Object) {
                ls.setItem(keySession, JSON.stringify(value));
            }
            else {
                ls.setItem(keySession, value);
            }
        },
        get: function () {
            var value = ls.getItem(keySession);
            if (value) {
                try {
                    return JSON.parse(value);
                }
                catch (error) {
                    return value;
                }
            }
            return value;
        },
        remove: function () {
            ls.removeItem(keySession);
        },
        clear: function () {
            ls.clear();
        },
    };
}
